import React, { useState, useEffect, useRef, Fragment, useMemo, act } from "react";
import LayoutHOC from "../LayoutHOC";
import CustomerListTable from "../customer/CustomerListTable";
import taskPodHead from "../customer/TaskPodHead";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  useReactTable,
  getCoreRowModel,
  ColumnFiltersState,
  getPaginationRowModel,
  FilterFn,
  getSortedRowModel,
  getGroupedRowModel,
  getExpandedRowModel,
  flexRender,
  getFilteredRowModel,
  sortingFns,
} from "@tanstack/react-table";
import { RankingInfo, rankItem, compareItems } from "@tanstack/match-sorter-utils";

import ScrollableTabs from "../UniversalComponents/ScrollableTabs";

import useRequireAuth from "../../utils/useRequireAuth";
import { useParams } from "react-router-dom";

import GentChart from "../GlobalFeature/Chart/GentChart";
import NavBarTabs from "../GlobalFeature/Others/NavBarTabs";
import {
  useDeleteProjectMutation,
  useDeleteTaskMutation,
  useFetchCustomerTaskPodAllCustomerDataQuery,
  useFetchCustomerTaskPodTableDataQuery,
  useLazyGetProjectTaskEnumQuery,
  useUpdateCustomerTaskPodTableDataMutation,
  useUpdateTaskCompletionMutation,
} from "../../utils/customer/customerTaskTable";
import {
  useFetchPersonInTableQuery,
  useLazyFetchCustomerTableQuery,
  useLazyFetchPersonInTableQuery,
} from "../../utils/customer/customerTable";
import { useCustomerTableMutation } from "../../utils/customer/customerTable";
import useFirstLetters from "../../hooks/LetterShow/useFirstLetters";
import FirstLetters from "../GlobalFeature/Letters/FirstLetters";
import QuickFilter from "../GlobalFeature/Table/HeadTop/QuickFilter";
import { getUserTokeData } from "../../utils/userSlice";
import { useLocation } from "react-router-dom";
import TaskPodRecurrenceCalendar from "../Task/TaskRecurrence/TaskPodRecurrenceCalendar";
import AddTaskPodModal from "../Task/AddNewPodModal";
import useFormatDate from "../../hooks/DateFormatter/useFormatDate";
import { Tooltip } from "@mui/material";
import styled from "@emotion/styled";
import RecurrenceIcon from "../Icons/RecurrenceIcon";
import ExceptionIcon from "../Icons/ExceptionIcon";
import CalendarIconWithTime from "../Icons/CalendarIconWithTime";
import EditOptionsModal from "../Task/TaskRecurrence/EditOptionsModal";
import { ReactComponent as ExpandCollapsIMG } from "../../assets/images/expandCollapsIMG.svg";
import { ReactComponent as SubTaskWhiteIcon } from "../../assets/images/subTaskWhiteIcon.svg";
import { ReactComponent as HandleToggleSubTaskIcon } from "../../assets/images/handleToggleSubTaskIcon.svg";
import EditOptionsTaskPodModal from "../Task/TaskRecurrence/EditOptionsTaskPodModal";
import { DayPilot } from "@daypilot/daypilot-lite-react";
import { ReactComponent as LeftDoubleArrow } from "../../assets/images/icons/leftArrowDouble.svg";
import { ReactComponent as RightDoubleArrow } from "../../assets/images/icons/rightArrowDouble.svg";
import CreatePortalHOC from "../GlobalFeature/Fields/CreatePortalHOC";
import {
  getPersonInitials,
  getPortalPosition,
  getSentenceCase,
  safeJsonParse,
} from "../../utils/utilityFunctions/stringUtility";
import { RiFileExcel2Line } from "react-icons/ri";
import Button from "../UniversalComponents/DefaultButton";
import CustomerEditTaskActivity from "../customer/CustomerEditTaskActivity";
import { render } from "@testing-library/react";
import { createColumnHelper } from "@tanstack/react-table";
import { ReactComponent as CustomerTaskNavIcon1 } from "../../assets/images/customerTaskNavIcon1.svg";
import { ReactComponent as CustomerTaskNavIcon2 } from "../../assets/images/customerTaskNavIcn2.svg";
import { ReactComponent as ThreeDotsVertical } from "../../assets/images/threeDotVertical.svg";
import { ReactComponent as ActivityIcon } from "../../assets/images/ActivityIcon.svg";
import { ReactComponent as SubTaskIcon } from "../../assets/images/subTaskIcon.svg";
import { ReactComponent as ProjectIcon } from "../../assets/images/icons/ProjectIcon.svg";
import SettingHeader from "../GlobalFeature/Table/HeadTop/SettingHeader";
import Loader from "../UniversalComponents/Loader";
import { pushAlert } from "../../utils/alertSlice";
import { useSidebar } from "../SidebarContext";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { checkAccessPermission } from "../../utils/utilityFunctions/localServices";
import SearchIcon from "../../assets/images/icons/SearchIcon";
import FilterIcon from "../../assets/images/icons/FilterIcon";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import ToDoActiveButton from "./ToDoActiveButton";
import AvatarName from "../UniversalComponents/AvatarName";
import ToggleSwitch from "../UniversalComponents/ToggleSwitch";
import { ReactComponent as GridIcon } from "../../assets/images/icons/GridIcon.svg";
import { ReactComponent as ListIcon } from "../../assets/images/icons/ListIcon.svg";
import KanBanBoard from "../Task/Kanban/KanBanBoard";
import TaskRadioButton from "../UniversalComponents/CompletionCheckbox";
import { ReactComponent as AddSubTaskDownArrow } from "../../assets/images/addSubTaskDownArrow.svg";
import BasicSelect from "../Task/BasicSelect";
import { ReactComponent as NewNoTaskIcon } from "../../assets/images/NewNoTaskIcon.svg";
// import { ReactComponent as NoFile } from "../../assets/images/NoFile.svg";
import AddViewProjectDrawer from "./AddViewProjectDrawer";

const leadTypeList1 = [
  { label: "Tasks", value: "task", rightTab: "5" },
  // { label: "Projects", value: "project", rightTab: "9" },
  { label: "Deals", value: "deal", rightTab: "10" },
  { label: "Leads", value: "lead", rightTab: "11" },
];

const leadTypeList2 = [
  { label: "Jobs", value: "project", rightTab: "8" },
  { label: "Projects", value: "projects", rightTab: "13" },
];

const stringData = (dateString) => {
  if (!dateString || dateString.trim() === "") return "";
  const data = dateString?.split("-");
  return `${data[2]}-${data[1]}-${data[0]}`;
};

const csvConfig = mkConfig({
  fieldSeparator: ",",
  filename: "sample", // export file name (without .csv)
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});
//download excel exclude column
const keysToExclude = ["assigned_to", "sub_tasks"];

// Export function
const exportExcel = (rows, Headers) => {
  const keyMap = Object.fromEntries(Headers?.map((item) => [item.value, item.label]) || []);
  console.log("rows", rows);

  const rowData = rows.map((row) => {
    return Object.fromEntries(
      Object.entries(row.original)
        .filter(([key]) => !keysToExclude.includes(key))
        .map(([key, value]) => {
          const newKey = keyMap[key] ?? key;
          try {
            const parsedValue = JSON.parse(value);

            if (Array.isArray(parsedValue)) {
              return [
                newKey,
                parsedValue
                  .map((item) => item.value ?? "")
                  .filter(Boolean)
                  .join("; ") || "",
              ];
            }

            if (parsedValue && typeof parsedValue === "object" && "value" in parsedValue) {
              return [newKey, parsedValue.value ?? ""];
            }
          } catch (e) {}

          return [newKey, value ?? ""];
        })
    );
  });
  console.log("rowDataobjectets", rowData);
  // const exportEnabledData = transformAndReorder(rowData, ["delegation", "tasks"]);
  // const csv = generateCsv(csvConfig)(exportEnabledData);
  const csv = generateCsv(csvConfig)(rowData);
  download(csvConfig)(csv);
  //download(csvConfig)(csv);
};

const fuzzyFilter = (row, columnId, value, addMeta) => {
  // Rank the item
  const itemRank = rankItem(row.getValue(columnId), value);

  // Store the itemRank info (addMeta may not exist in plain JavaScript)
  if (addMeta) {
    addMeta({
      itemRank,
    });
  }

  // Return if the item should be filtered in/out
  return itemRank.passed;
};
const fuzzySort = (rowA, rowB, columnId) => {
  let dir = 0;

  // Only sort by rank if the column has ranking information
  if (rowA.columnFiltersMeta && rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(rowA.columnFiltersMeta[columnId]?.itemRank, rowB.columnFiltersMeta[columnId]?.itemRank);
  }

  // Provide an alphanumeric fallback for when the item ranks are equal
  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};

const getTabvalues = (RightTab) => {
  switch (String(RightTab)) {
    case "5":
      return "task";
    case "8":
      return "project";
    case "10":
      return "deal";
    case "11":
      return "lead";
    case "13":
      return "projects";

    default:
      break;
  }
};

const toggleStatus = (value) => {
  if (value === "Completed") return "Not Started";
  return "Completed";
};
const AllTasks = ({
  customerTask,
  taskOpenTab,
  // leadType,
  disableLeadTypeChange,
  customerData,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();

  const { leadTypePath } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const rightTab = searchParams.get("RightTab"); // returns "8"

  const [resetPageIndex, setResetPageIndex] = useState(true);

  // const hashValue = location.hash.substring(1);
  const hashValue = location.hash;

  const [quiFilter, setQuiFilter] = useState();
  const [initialFilter, setInitialFilter] = useState([]);

  const [customer, setCustomer] = useState([]);
  const [customerMainData, setCustomerMainData] = useState([]);
  // const [totalData,setTotalData]=useState(null)

  // Object.keys(customerMainData.task_count)[0]

  const [activeTab, setActiveTab] = useState(Boolean(hashValue.replace("#", "")) ? hashValue : "#all");

  const token = useRequireAuth();

  const storedData = localStorage.getItem("company_data");

  const companyId = storedData ? JSON.parse(storedData) : null;

  const [customerTablePagination, setCustomerTablePagination] = useState("");
  const { name: taskPod, id: customerId } = useParams();
  const [refreshKey, setRefreshKey] = useState(0);
  const showMessage = useSelector((state) => state.tasks.showMessage);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [editData, setEditData] = useState();
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [view, setView] = useState("Day");
  const [startDate, setStartDate] = useState(DayPilot.Date.today());

  const [isGridActive, setIsGridActive] = useState(false);
  const [isListView, setIsListView] = useState(true);

  const [calview, setCalView] = useState(false);
  const [newPayload, setNewPayload] = useState([]);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isSearchActive, setIsSearchActive] = useState(null);

  const [subTaskOpen, setSubTaskOpen] = useState([]);

  const [userDataId, setUserDataId] = useState([]);
  const [totalData, setTotalData] = useState(null);

  const [showTabList, setShowTabList] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [storedThead, setStoredThead] = useState(taskPodHead);
  const [isHovered, setIsHovered] = useState(false);
  const [isFilterHovered, setIsFilterHovered] = useState(false);
  const taskFormSubmit = useSelector((state) => state.tasks);
  const [groupedHeader, setGroupedHeaders] = useState([]);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [leadType, setLeadType] = useState(leadTypePath?.toLowerCase() ?? getTabvalues(rightTab));
  const [openAddProject, setOpenAddProject] = useState(false);
  const [projectFormData, setProjectFormData] = useState(null);
  const scrollDiv = useRef();
  const moreTabRef = useRef();
  const tabListRef = useRef();

  const { data: customerTaskPodAllCustomer } = useFetchCustomerTaskPodAllCustomerDataQuery({
    token,
    companyId,
    // search: customerSearch,
  });

  const [fetchFieldValues, { data: projectFieldList, isFetching: projectFieldListLoading }] =
    useLazyGetProjectTaskEnumQuery();
  let scrollInterval;
  // = useRef();
  const sidebarContext = useSidebar();
  const setheaderProps = sidebarContext?.setheaderProps;

  useEffect(() => {
    if (leadTypePath) setheaderProps({ name: "To Do Hub" });

    return () => {
      if (leadTypePath) setheaderProps(null);
    };
  }, [setheaderProps]);

  useEffect(() => {
    if (leadTypePath) {
      setLeadType(leadTypePath?.toLowerCase());
    }
    if (rightTab) {
      setLeadType(getTabvalues(rightTab));
    }
  }, [rightTab, leadTypePath]);

  // const isProject = leadType?.toLowerCase() === "project";
  useEffect(() => {
    let customerTaskActiveColumns = {};
    let projectActiveColumns = {};
    if (customerTask) {
      customerTaskActiveColumns = {
        customer_name: false,
        customer_display_name: false,
      };
    }
    const projectKeys = [
      "customer_name",
      "contact_name",
      "project_name",
      "project_code",
      "link_to_project_pod",
      "legal_entity",
      "gfpo_company",
      "software",
      "tax_year_end",
      "annual_accounts_month",
      "project_partner",
      "manager_reviewer",
      "project_status",
      "start_date",
      "end_date",
      "created_by",
      "updated_by",
      "created_at",
      "updated_at",
      "completionAction",
    ];

    let projectsObject = {};
    let isNotprojectsObject = {};

    projectKeys.forEach((key) => {
      projectsObject[key] = null; // or any default value
    });

    projectKeys.forEach((key) => {
      projectsObject[key] = key === "completionAction" ? false : true;
    });

    projectKeys.forEach((key) => {
      isNotprojectsObject[key] = key === "completionAction" ? true : false;
    });

    switch (leadType) {
      case "task":
        projectActiveColumns = {
          // ...isNotprojectsObject
          job_status_funnel: false,
          service_name: true,
          return_type: false,
          complexity: false,
          status_date: true,
          project_name: false,
          manager_reviewer: false,
          tax_year_end: false,
          project_review_manager: false,
          billing_status: false,
          billing_date: false,
          invoice_number: false,
          time_tracked: false,
          target_delivery_date: false,
          payment_status: false,
          description: false,
        };
        break;
      case "project":
        projectActiveColumns = {
          job_status_funnel: true,
          service_name: true,
          return_type: true,
          complexity: true,
          status_date: true,
          project_name: true,
          manager_reviewer: true,
          tax_year_end: true,
          project_review_manager: true,
          project_review_manager: true,
          billing_status: true,
          billing_date: true,
          invoice_number: true,
          time_tracked: true,
          target_delivery_date: true,
          payment_status: true,
          description: true,

          // ...isNotprojectsObject
        };
        break;
      case "deal":
        projectActiveColumns = {
          job_status_funnel: true,
          service_name: true,
          return_type: false,
          complexity: false,
          status_date: false,
          project_name: false,
          manager_reviewer: false,
          tax_year_end: false,
          project_review_manager: false,
          project_review_manager: false,
          billing_status: false,
          billing_date: false,
          invoice_number: false,
          time_tracked: false,
          target_delivery_date: false,
          payment_status: false,
          description: false,

          // ...isNotprojectsObject
        };
      case "lead":
        projectActiveColumns = {
          job_status_funnel: true,
          service_name: true,
          return_type: false,
          complexity: false,
          status_date: false,
          project_name: false,
          manager_reviewer: false,
          tax_year_end: false,
          project_review_manager: false,
          project_review_manager: false,
          billing_status: false,
          billing_date: false,
          invoice_number: false,
          time_tracked: false,
          target_delivery_date: false,
          payment_status: false,
          description: false,

          // ...isNotprojectsObject
        };

      case "projects":
        projectActiveColumns = {
          job_status_funnel: false,
          service_name: false,
          return_type: false,
          complexity: false,
          status_date: false,
          project_name: false,
          manager_reviewer: false,
          tax_year_end: false,
          project_review_manager: false,
          project_review_manager: false,
          billing_status: false,
          billing_date: false,
          invoice_number: false,
          time_tracked: false,
          target_delivery_date: false,
          payment_status: false,
          description: false,
          assigned_to: false,
          priority: false,
          activity: false,
          status: false,
          subject: false,
          task_pod: false,
          customer_display_name: false,

          // ...projectsObject
        };
        break;

      default:
        break;
    }

    setColumnVisibility((prev) => {
      return {
        ...prev,
        ...projectActiveColumns,
        ...customerTaskActiveColumns,
      };
    });
  }, [leadType, rightTab]);
  function scrollTheElement(elem, direction) {
    const scrollAmount = 50; // Amount to scroll in pixels per interval

    scrollInterval = setInterval(() => {
      if (direction === "left") {
        elem.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else if (direction === "right") {
        elem.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }, 50);
  }

  function stopScroll() {
    // Stop scrolling when the button is released
    clearInterval(scrollInterval);
  }

  function tabListHandler(tabName) {
    // window.location.href = `#${tabName}`
    const element = document.getElementById(`tab-${tabName}`);
    element.scrollIntoView({ behavior: "smooth" });
    handleTabClick(`#${tabName}`);
  }

  const getMoreTabStatus = (ele) => {
    if (ele && ele.current) {
      const rec = ele.current.getBoundingClientRect();

      if (rec.width > 850) {
        setShowLeftArrow(true);
        setShowRightArrow(true);
        // return true
      }
    }

    return false;
  };
  const toggleFilterActive = () => {
    // console.log("insidetogglefilter");
    resetFilters();
    setIsFilterActive((prevState) => !prevState);
  };

  useEffect(() => {
    if (!isFilterActive) {
      setIsFilterHovered(false);
    }
  }, [isFilterActive]);

  const toggleSearchIcon = () => {
    setIsSearchActive((prevState) => !prevState);
  };
  useEffect(() => {
    if (!isSearchActive) {
      setIsHovered(false);
    }
  }, [isSearchActive]);
  const pageNumbers = () => {
    const totalPages = table.getPageCount();
    const currentPage = table.getState().pagination.pageIndex + 1; // TanStack uses 0-based index

    const pages = [];

    if (totalPages <= 6) {
      // If total pages are 6 or fewer, show all
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1); // Always show the first page

      if (currentPage > 4) {
        pages.push("..."); // Ellipsis for pages before the current range
      }

      // Show pages around the current page
      for (let i = Math.max(2, currentPage - 2); i <= Math.min(totalPages - 1, currentPage + 2); i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 3) {
        pages.push("..."); // Ellipsis for pages after the current range
      }

      pages.push(totalPages); // Always show the last page
    }

    return pages;
  };

  const [open, setOpen] = useState(false);
  const [dropUp, setDropUp] = useState(false);

  // const pageSizes = [25, 50, 100];

  const pageSizes = [
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (open && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.bottom + 100 > windowHeight) {
        setDropUp(true);
      } else {
        setDropUp(false);
      }
    }
  }, [open]);

  const child1Ref = useRef(null);
  const tableRef = useRef(null);
  const scrollbarWrapperRef = useRef(null);
  const paginationRef = useRef(null);
  const handleScroll = (direction) => {
    if (scrollbarWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value to control the scroll speed
      const currentScroll = scrollbarWrapperRef.current.scrollLeft;

      // Correct scrolling logic based on direction
      if (direction === "next") {
        // Scroll right (increase scrollLeft)
        scrollbarWrapperRef.current.scrollLeft = currentScroll + scrollAmount;
      } else if (direction === "previous") {
        // Scroll left (decrease scrollLeft), but don't go below 0
        scrollbarWrapperRef.current.scrollLeft = Math.max(currentScroll - scrollAmount, 0);
      }
    }
  };

  const [scrollbarWidth, setScrollbarWidth] = useState("100%");

  //for setting column Order
  useEffect(() => {
    const order = storedThead.map((item) => Object.keys(item)[0]);
    setColumnOrder(order);
  }, [storedThead]);

  useEffect(() => {
    const child1 = child1Ref.current;
    const scrollbarWrapper = scrollbarWrapperRef.current;
    if (child1 && scrollbarWrapper) {
      const handleScroll = () => {
        if (child1.scrollLeft !== scrollbarWrapper.scrollLeft) {
          child1.scrollLeft = scrollbarWrapper.scrollLeft;
        }
      };

      const handleChild1Scroll = () => {
        if (scrollbarWrapper.scrollLeft !== child1.scrollLeft) {
          scrollbarWrapper.scrollLeft = child1.scrollLeft;
        }
      };

      scrollbarWrapper.addEventListener("scroll", handleScroll);
      child1.addEventListener("scroll", handleChild1Scroll);
      // Cleanup event listeners on component unmount
      // return () => {
      //     scrollbarWrapper.removeEventListener('scroll', handleScroll);
      //     child1.removeEventListener('scroll', handleChild1Scroll);
      // };
    }
  }, []);

  const renderTabs = () => (
    <>
      {customerTableALL?.task_count &&
        Object.entries(customerTableALL.task_count).map(([key, count], i) => (
          <>
            <li key={key} id={`tab-${key}`}>
              <a
                href={`#${key}`}
                onClick={() => handleTabClick(`#${key}`)}
                className={`flex min-w-[69px] justify-center items-center py-1 px-2.5 focus:block whitespace-nowrap 
            leading-normal font-normal text-sm capitalize rounded-[50px] bg-white border 
            ${activeTab === `#${key}` ? "border-2C495D text-1D4469" : "border-D2DAE1 text-848687"}  
            ${key.toLowerCase() === "overdue" && "text-FF3612"} `}
              >
                {key}
              </a>
            </li>
          </>
        ))}
    </>
  );

  useEffect(() => {
    // console.log("recc useEF",)
    getMoreTabStatus(tabListRef);
  }, [renderTabs]);

  // const handleScroll = () => {

  //   if (scrollDiv.current && scrollDiv.current.scrollLeft >30) {
  //    setShowLeftArrow(true)
  //   }
  //   if((scrollDiv.current && scrollDiv.current.scrollLeft <30)){
  //       setShowLeftArrow(false)
  //     }
  // };
  // const [sorting, setSorting] = useState([]);
  const [grouping, setGrouping] = useState([]);
  // const [columnVisibility, setColumnVisibility] = useState({});
  const [rowSelection, setRowSelection] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [selectedCell, setSelectedCell] = useState(null); // Track selected cell
  const [inputValue, setInputValue] = useState(""); // Track the input value
  const [expanded, setExpanded] = useState({});
  const [sorting, setSorting] = React.useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [isPopupOpenActivity, setIsPopupOpenActivity] = useState(false);
  const [popupItemId, setPopupItemId] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const [extraField, setExtraField] = useState(false);
  const [taskpodPayload, setTaskpodPayload] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteData, setDeleteData] = useState(false);
  const [isCheckListOpen, setIsCheckListOpen] = useState(false);
  const [kanban, setKanBan] = useState("list");
  const [updateCounter, setUpdateCounter] = useState(0);
  // const [isListView, setIsListView] = useState(true);

  const handleMenuToggle = () => {
    setMenuVisible((prev) => !prev);
    setExtraField(false);
  };

  const columnHelper = createColumnHelper();
  const dropdownRef = useRef(null);
  const [subtaskExpanded, setSubtaskExpanded] = useState({});

  const toggleSubtaskExpanded = (event, rowId) => {
    event.stopPropagation();
    setSubtaskExpanded((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  useEffect(() => {
    function handleOutsideClick(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null); // Close the dropdown
      }
    }

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [setOpenDropdownId]);
  const toggleRowExpansion = (rowId) => {
    setExpanded((prevExpanded) => {
      const newExpanded = { ...prevExpanded };
      if (newExpanded[rowId]) {
        delete newExpanded[rowId]; // Collapse the row if already expanded
      } else {
        newExpanded[rowId] = true; // Expand the row if collapsed
      }
      return newExpanded;
    });
  };
  const handleCustomerNameClick = (id) => {
    window.open(`/customer/${id}`, "_blank");
  };
  const handleMouseEnterDebounced = (item) => {
    // console.log("itemabhi", item);

    setPopupItemId(item?.id);
    setIsPopupOpenActivity(true);
  };
  useEffect(() => {
    // console.log("popupabhishek", popupItemId);
  }, [popupItemId]);

  const handleClosed = () => {
    setPopupItemId(null);
    setIsPopupOpen(false);
    // activityClosed();
  };
  const jsonStringFilter = (row, columnId, filterValue) => {
    //const cellValue = JSON.stringify(row.getValue(columnId) || ""); // Convert to string
    const cellValue = row.getValue(columnId); // Convert to string

    // return cellValue.toLowerCase().includes(filterValue.toLowerCase());
    return cellValue?.some((person) => person.name?.toLowerCase().includes(filterValue.toLowerCase()));
  };

  const handleProjectIconClick = (e, data) => {
    e.stopPropagation();
    setEditData(data);
    setIsCheckListOpen(true);
  };

  const handleClickCompleted = (e, id, task_status_id, taskData) => {
    e.stopPropagation();
    setUpdateCounter((prevCounter) => prevCounter + 1);
    setCompletedTasks((prevTasks) => ({
      ...prevTasks,
      [id]: {
        task_status_id: !prevTasks[id] ? task_status_id : null,
        status: toggleStatus(!prevTasks[id] ? taskData?.status : prevTasks[id]?.status),
      },
    }));

    const updatedTasks = {
      ...completedTasks,
      [id]: {
        task_status_id: !completedTasks[id] ? task_status_id : null,
        status: toggleStatus(!completedTasks[id] ? taskData?.status : completedTasks[id]?.status),
      },
    };

    const CompleteData = {
      task_id: Object.keys(updatedTasks).filter((key) => updatedTasks[key]?.status === "Completed"),
      task_status_id: Object.keys(updatedTasks)
        .filter((key) => updatedTasks[key]?.status === "Completed")
        .map((key) => updatedTasks[key]?.task_status_id),
      updates: {
        status: "Completed",
      },
    };

    const NotStartedData = {
      task_id: Object.keys(updatedTasks).filter((key) => updatedTasks[key]?.status === "Not Started"),
      task_status_id: Object.keys(updatedTasks)
        .filter((key) => updatedTasks[key]?.status === "Not Started")
        .map((key) => updatedTasks[key]?.task_status_id),
      updates: {
        status: "Not Started",
      },
    };

    const completedPayload = {
      data: CompleteData,
    };

    const NotStartedPayload = {
      data: NotStartedData,
    };

    const revertCompletionChanges = () => {
      setCompletedTasks({});
    };

    const updateApi = async () => {
      const apiResponseCompleted =
        Object.keys(completedPayload?.data?.task_id)?.length && (await updateTaskCompletion(completedPayload).unwrap());
      const apiResponseNS =
        Object.keys(NotStartedPayload?.data?.task_status_id?.filter((key) => key))?.length &&
        (await updateTaskCompletion(NotStartedPayload).unwrap());

      if (apiResponseCompleted?.success || apiResponseNS?.success) {
        dispatch(pushAlert({ type: "success", message: "Task updated successfully", visible: true }));
        // refetchCustomerData();
        // setCompletedTasks({});
      } else {
        dispatch(pushAlert({ type: "danger", message: "Task Not updated", visible: true }));
        revertCompletionChanges();
      }
    };

    dispatch(
      pushAlert({
        type: "revert",
        message: "",
        visible: true,
        counter: updateCounter,
        onConfirm: updateApi,
        onRevert: revertCompletionChanges,
      })
    );
  };

  const isMyTaskCompleted = (status, id) => {
    if (completedTasks[id] ? completedTasks[id]?.status === "Completed" : status === "Completed") {
      return true;
    }
    return false;
  };

  const TaskCompletionCheckbox = React.memo(({ id, isChecked, task_status_id, taskData }) => {
    return (
      <div
        className="flex items-center text-black"
        onClick={(e) => handleClickCompleted(e, id, task_status_id, taskData)}
      >
        <TaskRadioButton isChecked={isChecked} />
      </div>
    );
  });

  const getFieldValue = async (enumValues, entity = "project") => {
    const payload = {
      entity: entity,
      field: enumValues,
    };
    const response = await fetchFieldValues({ payload }).unwrap();
    if (response?.success) {
      dispatch(pushAlert({ message: response?.message, type: "success", visible: true }));
    } else {
      dispatch(pushAlert({ message: response?.message, type: "danger", visible: true }));
    }
  };

  // customer_name: true,
  // customer_display_name: true,
  // contact_name: true,
  // project_name: true,
  // project_code: true,
  // link_to_project_pod: true,
  // legal_entity:true ,
  // gfpo_company: true,
  // software: true,
  // tax_year_end:true ,
  // annual_accounts_month: true,
  // project_partner:true ,
  // manager_reviewer: true,
  // project_status: true,
  // start_date: true,
  // end_date: true,
  // created_by: true,
  // updated_by: true,
  // created_at: true,
  // updated_at: true,
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "completionAction",
        header: "",
        cell: (info) => {
          // const { project_name } = info.row.original;

          return (
            <TaskCompletionCheckbox
              key={info.row.original.id}
              id={info.row.original.id}
              task_status_id={info.row.original.task_status_id}
              taskData={info.row.original}
              isChecked={
                completedTasks[info.row.original.id]
                  ? completedTasks[info.row.original.id]?.status === "Completed"
                  : info.row.original.status === "Completed"
              }
            />
          );
        },
      },
      {
        accessorKey: "customer_name",
        header: "Company Name",
        meta: { position: "left" },
        enableFiltering: false,
        cell: (info) =>
          info.row.original?.sub_tasks || info.row.original?.is_project ? (
            <p
              className="text-2999BC"
              onClick={() => {
                handleCustomerNameClick(info.row.original.customer_id);
              }}
              style={
                isMyTaskCompleted(info.row.original.status, info.row.original.id)
                  ? { color: "grey", textDecoration: "line-through" }
                  : {}
              }
            >
              {info.getValue()}
            </p>
          ) : (
            <p className=""></p>
          ),
      },

      {
        accessorKey: "customer_display_name",
        header: "Contact Name",

        meta: { position: "left" },
        enableFiltering: false,
        cell: (info) => (
          <p
            className=""
            style={
              isMyTaskCompleted(info.row.original.status, info.row.original.id)
                ? { color: "grey", textDecoration: "line-through" }
                : {}
            }
          >
            {info.getValue()}
          </p>
        ),
      },
      {
        accessorKey: "contact_name",
        header: "Contact Name",
        cell: (info) => {
          // const { project_name } = info.row.original;
          return <div className="flex items-center text-black">{info.getValue()}</div>;
        },
      },
      {
        accessorKey: "project_name",
        header: "Project Name",
        cell: (info) => {
          // const { project_name } = info.row.original;
          return <div className="flex items-center text-black">{info.getValue()}</div>;
        },
      },
      {
        accessorKey: "project_code",
        header: "Project Code",
        cell: (info) => {
          // const { project_code } = info.row.original;
          return <div className="flex items-center text-black">{info.getValue()}</div>;
        },
      },
      {
        accessorKey: "link_to_project_pod",
        header: "Project Pod",
        cell: (info) => {
          // const { link_to_project_pod } = info.row.original;
          return <div className="flex items-center text-black">{info.getValue()}</div>;
        },
      },
      {
        accessorKey: "legal_entity",
        header: "Legal Entity",
        cell: (info) => {
          // const { link_to_project_pod } = info.row.original;
          return <div className="flex items-center text-black">{info.getValue()}</div>;
        },
      },
      {
        accessorKey: "gfpo_company",
        header: "GFPO Company",
        cell: (info) => {
          // const { link_to_project_pod } = info.row.original;
          return <div className="flex items-center text-black">{info.getValue()}</div>;
        },
      },
      {
        accessorKey: "software",
        header: "Software",
        cell: (info) => {
          // const { link_to_project_pod } = info.row.original;
          return <div className="flex items-center text-black">{info.getValue()}</div>;
        },
      },

      {
        accessorKey: "subject",
        header: `${getSentenceCase(leadType === "project" ? "Job" : leadType)} name`,
        meta: { position: "left" },
        cell: (info) => {
          const { subject, sub_tasks, category_id, checklists } = info.row.original;
          const rowId = info.row.id;

          return (
            <div
              className="flex justify-between mr-2 "
              style={
                isMyTaskCompleted(info.row.original.status, info.row.original.id)
                  ? { color: "grey", textDecoration: "line-through" }
                  : {}
              }
            >
              <p className={`${sub_tasks ? "" : "truncate whitespace-nowrap overflow-hidden text-ellipsis"}`}>
                {subject}
              </p>
              {sub_tasks?.length > 0 && (
                <button
                  className={`rounded p-1 ms-4 ${subtaskExpanded[rowId] ? "bg-blue-900" : "bg-[#F1F1F1]"}`}
                  onClick={(e) => toggleSubtaskExpanded(e, info.row.id)}
                >
                  {subtaskExpanded[info.row.id] ? (
                    <CustomerTaskNavIcon1 />
                  ) : (
                    // Replace with your SVG component for expanded state
                    <CustomerTaskNavIcon2 /> // Replace with your SVG component for collapsed state
                  )}
                </button>
              )}
              {category_id === "project" && checklists?.length > 0 && (
                <button
                  onClick={(e) => {
                    handleProjectIconClick(e, info.row.original);
                  }}
                >
                  <ProjectIcon />
                </button>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "task_pod",
        header: `${leadType === "task" ? "Task" : "Project"} pod`,

        meta: { position: "left" },
        enableFiltering: false,
        cell: (info) => <p className="">{info.getValue()}</p>,
      },
      {
        accessorKey: "start_date",
        header: "Start Date",
        id: "start_date",
        cell: ({ row }) => {
          const { start_date, end_date, is_recurrence, is_exception } = row.original;
          const formatDate = (dateString) => {
            if (!dateString) {
              return; // Return a placeholder when dateString is null or undefined
            }
            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.toLocaleString("default", { month: "short" });
            return `${day} ${month}`;
          };
          const recurrenceSvg =
            is_recurrence && !is_exception ? (
              <button
                className=" ms-4"
                onClick={() => {
                  // handleRecurrence(item?.id?.value, item, header);
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path
                    d="M14.0975 14.0974C16.8958 11.2896 16.8958 6.71539 14.0975 3.90753L12.6048 5.40025V0.902874H17.1022L15.3647 2.64039C18.8781 6.14902 18.8781 11.8559 15.3647 15.3694C13.1472 17.5821 10.0609 18.4028 7.20025 17.8172V15.9645C9.58573 16.5837 12.2304 15.9645 14.0975 14.0974Z"
                    fill="#2999BC"
                  />
                  <path
                    d="M2.63567 2.64039C4.85316 0.418098 7.93941 -0.402662 10.8001 0.182909V2.03562C8.41459 1.41645 5.76512 2.04522 3.90281 3.90753C1.09495 6.71539 1.09495 11.2896 3.90281 14.0974L5.39554 12.6047V17.1069H0.893357L2.63087 15.3694C-0.877756 11.8559 -0.877757 6.14902 2.63567 2.64039Z"
                    fill="#2999BC"
                  />
                </svg>
              </button>
            ) : is_exception ? (
              <button className=" ms-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.99239 4.69194C2.88604 4.78902 2.78143 4.88905 2.67866 4.99205C-0.892074 8.5579 -0.892072 14.3579 2.67378 17.9286L0.907927 19.6945H5.48354V15.1189L3.96646 16.636C1.11281 13.7823 1.11281 9.13351 3.96646 6.27985C3.98759 6.25873 4.00881 6.23776 4.03013 6.21695L2.99239 4.69194ZM12.1431 18.1392C10.6205 18.8169 8.91213 18.9474 7.31768 18.5335V20.4164C9.28283 20.8187 11.3527 20.568 13.1839 19.6687L12.1431 18.1392ZM15.7657 17.7747L14.7093 16.2224C17.1651 13.3496 17.0378 8.99949 14.3274 6.27985L12.8104 7.79693V3.22619H17.3811L15.6152 4.99205C19.1351 8.50711 19.1853 14.1931 15.7657 17.7747ZM6.75814 4.53783L5.69861 2.98081C7.37784 2.29724 9.21891 2.13477 10.9762 2.49449V4.37741C9.59137 4.01796 8.11897 4.07235 6.75814 4.53783Z"
                    fill="#2999BC"
                  />
                  <path d="M2.41016 1L16.0199 21" stroke="#2999BC" stroke-width="2" stroke-linecap="round" />
                </svg>
              </button>
            ) : (
              <CalendarIconWithTime />
            );
          return (
            <div className="flex justify-between items-center ">
              <p>{formatDate(start_date)}</p>
              {/* <div className="">{recurrenceSvg}</div> */}
            </div>
          );
        },
      },

      {
        accessorKey: "end_date",
        header: "End Date",
        id: "end_date",
        cell: ({ row }) => {
          const { start_date, end_date, is_recurrence, is_exception } = row.original;
          const formatDate = (dateString) => {
            if (!dateString) {
              return; // Return a placeholder when dateString is null or undefined
            }
            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.toLocaleString("default", { month: "short" });
            return `${day} ${month}`;
          };
          const isGroupedRow = row.getIsGrouped();

          const recurrenceSvg =
            is_recurrence && !is_exception ? (
              <button
                className=" ms-4"
                onClick={() => {
                  // handleRecurrence(item?.id?.value, item, header);
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path
                    d="M14.0975 14.0974C16.8958 11.2896 16.8958 6.71539 14.0975 3.90753L12.6048 5.40025V0.902874H17.1022L15.3647 2.64039C18.8781 6.14902 18.8781 11.8559 15.3647 15.3694C13.1472 17.5821 10.0609 18.4028 7.20025 17.8172V15.9645C9.58573 16.5837 12.2304 15.9645 14.0975 14.0974Z"
                    fill="#2999BC"
                  />
                  <path
                    d="M2.63567 2.64039C4.85316 0.418098 7.93941 -0.402662 10.8001 0.182909V2.03562C8.41459 1.41645 5.76512 2.04522 3.90281 3.90753C1.09495 6.71539 1.09495 11.2896 3.90281 14.0974L5.39554 12.6047V17.1069H0.893357L2.63087 15.3694C-0.877756 11.8559 -0.877757 6.14902 2.63567 2.64039Z"
                    fill="#2999BC"
                  />
                </svg>
              </button>
            ) : is_exception ? (
              <button className=" ms-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.99239 4.69194C2.88604 4.78902 2.78143 4.88905 2.67866 4.99205C-0.892074 8.5579 -0.892072 14.3579 2.67378 17.9286L0.907927 19.6945H5.48354V15.1189L3.96646 16.636C1.11281 13.7823 1.11281 9.13351 3.96646 6.27985C3.98759 6.25873 4.00881 6.23776 4.03013 6.21695L2.99239 4.69194ZM12.1431 18.1392C10.6205 18.8169 8.91213 18.9474 7.31768 18.5335V20.4164C9.28283 20.8187 11.3527 20.568 13.1839 19.6687L12.1431 18.1392ZM15.7657 17.7747L14.7093 16.2224C17.1651 13.3496 17.0378 8.99949 14.3274 6.27985L12.8104 7.79693V3.22619H17.3811L15.6152 4.99205C19.1351 8.50711 19.1853 14.1931 15.7657 17.7747ZM6.75814 4.53783L5.69861 2.98081C7.37784 2.29724 9.21891 2.13477 10.9762 2.49449V4.37741C9.59137 4.01796 8.11897 4.07235 6.75814 4.53783Z"
                    fill="#2999BC"
                  />
                  <path d="M2.41016 1L16.0199 21" stroke="#2999BC" stroke-width="2" stroke-linecap="round" />
                </svg>
              </button>
            ) : (
              <CalendarIconWithTime />
            );
          return (
            <div className="flex justify-between items-center   ">
              <p>{formatDate(end_date)}</p>
              {!isGroupedRow && <div className="">{recurrenceSvg}</div>}
            </div>
          );
        },
      },

      {
        accessorKey: "assigned_to",
        header: "Assignee",
        cell: (info) => {
          const { assigned_to } = info.row.original;

          return (
            <div className="flex">
              {assigned_to?.map((person, index) => {
                if (index < 3) {
                  // Render the first 3 persons
                  const { initials, background } = getPersonInitials(person);

                  return (
                    <span key={index} className="mr-2 flex items-center justify-center ">
                      <AvatarName name={initials} size="medium" bgColor={background} />
                    </span>
                  );
                } else if (index === 3) {
                  // Render the count of remaining persons
                  const remainingCount = assigned_to.length - 3;
                  if (remainingCount > 0) {
                    return (
                      <span
                        key="remaining-count"
                        className="mr-2 flex items-center justify-center rounded-full bg-gray-500 text-white"
                        style={{
                          width: "26px",
                          height: "26px",
                          fontSize: "12px",
                        }}
                      >
                        +{remainingCount}
                      </span>
                    );
                  }
                }
                return null;
              })}
            </div>
          );
        },
        filterFn: jsonStringFilter,
      },

      {
        accessorKey: "project_partner",
        header: "Project Partner",
        cell: (info) => {
          // const { manager_reviewer } = info.row.original;
          return <div className="flex items-center text-black">{safeJsonParse(info.getValue() || "{}")?.name}</div>;
        },
      },
      {
        accessorKey: "manager_reviewer",
        header: "Review Manager",
        cell: (info) => {
          const { manager_reviewer } = info.row.original;
          return <div className="flex items-center text-black">{safeJsonParse(manager_reviewer || "{}")?.name}</div>;
        },
      },
      {
        accessorKey: "tax_year_end",
        header: "Tax Year",
        cell: (info) => {
          // const { tax_year_end } = info.row.original;
          return <div className="flex items-center text-black">{info.getValue()}</div>;
        },
      },
      {
        accessorKey: "status",
        header: "Status",
        cell: (info) => {
          const { status, status_colour_code, sub_tasks } = info.row.original;
          return (
            <div className="flex items-center">
              <p
                className="px-3 py-1 rounded-full text-white border  h-[22px] flex items-center"
                style={{
                  backgroundColor: sub_tasks ? "" : `${status_colour_code}1A`, // Add alpha manually for transparency if supported by CSS (e.g., `#FCB72E1A` for 10% opacity)
                  color: sub_tasks ? status_colour_code : "black",
                  borderColor: status_colour_code,
                }}
              >
                {status}
              </p>
            </div>
          );
        },
      },
      {
        accessorKey: "job_status_funnel",
        header: "Job Status/Funnel",
        cell: (info) => {
          const { job_status_funnel } = info.row.original;
          return <div className="flex items-center text-black">{job_status_funnel}</div>;
        },
      },
      // {
      //   accessorKey: "project_status",
      //   header: "Project Status",
      //   cell: (info) => {
      //     const { project_status } = info.row.original;
      //     return <div className="flex items-center text-black">{project_status}</div>;
      //   },
      // },
      {
        accessorKey: "priority",
        header: "Priority",
        cell: (info) => {
          const { priority, priority_colour_code } = info.row.original;
          return (
            <div
              className="rounded-full w-6 h-6 flex items-center justify-center  text-[12px]"
              style={{
                backgroundColor: priority_colour_code && `${priority_colour_code}1A`, // Add alpha manually for transparency if supported (e.g., `#FCB72E1A` for 10% opacity)
                color: priority_colour_code,
                borderColor: priority_colour_code,
              }}
            >
              {priority?.slice(0, 1).toUpperCase()}
            </div>
          );
        },
      },

      {
        accessorKey: "activity",
        header: "Activity",
        aggregatedCell: () => "", // Return empty for aggregated cells

        cell: (info) => {
          const rowKey = `${info.row.original?.id}-${popupItemId}`;
          if (!info.row.original?.sub_tasks) {
            return <p></p>;
          }

          return (
            <div key={rowKey}>
              <div onClick={() => handleMouseEnterDebounced(info.row.original)}>
                <p className="">
                  <ActivityIcon />
                </p>
              </div>
              {popupItemId === info.row.original?.id && isPopupOpenActivity && (
                <>
                  <CustomerEditTaskActivity
                    open={popupItemId === info.row.original?.id && isPopupOpenActivity}
                    activityid={info.row.original?.id}
                    cross
                    type="Task"
                    onClose={handleClosed}
                    handleNotification={handleClosed}
                    item={info.row.original}
                  />
                </>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "status_date",
        header: "Due Date",
        id: "status_date",
        cell: (info) => {
          const { status_date } = info.row.original;
          const formatDate = (dateString) => {
            // if (!dateString) {
            //   return; // Return a placeholder when dateString is null or undefined
            // }
            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.toLocaleString("default", { month: "short" });
            return `${day} ${month}`;
          };

          return (
            <div className="flex justify-between items-center ">
              <p>{formatDate(status_date)}</p>
              {/* <div className="">{recurrenceSvg}</div> */}
            </div>
          );
        },
      },

      {
        accessorKey: "service_name",
        header: "Service Name",
        cell: (info) => {
          const { service_name } = info.row.original;
          return <div className="flex items-center text-black">{service_name}</div>;
        },
      },
      {
        accessorKey: "return_type",
        header: "Return Type",
        cell: (info) => {
          const { return_type } = info.row.original;
          return <div className="flex items-center text-black">{return_type}</div>;
        },
      },

      {
        accessorKey: "complexity",
        header: "Job Complexity",
        cell: (info) => {
          const { complexity } = info.row.original;
          return <div className="flex items-center text-black">{complexity}</div>;
        },
      },
      {
        accessorKey: "billing_status",
        header: "Billing Status",
        cell: (info) => {
          const { billing_status } = info.row.original;
          return <div className="flex items-center text-black">{billing_status}</div>;
        },
      },
      {
        accessorKey: "billing_date",
        header: "Billing Date",
        cell: (info) => {
          const { billing_date } = info.row.original;
          return <div className="flex items-center text-black">{billing_date}</div>;
        },
      },
      {
        accessorKey: "invoice_number",
        header: "Invoice Number",
        cell: (info) => {
          const { invoice_number } = info.row.original;
          return <div className="flex items-center text-black">{invoice_number}</div>;
        },
      },
      {
        accessorKey: "time_tracked",
        header: "Time Tracked",
        cell: (info) => {
          const { time_tracked } = info.row.original;
          return <div className="flex items-center text-black">{time_tracked}</div>;
        },
      },
      {
        accessorKey: "target_delivery_date",
        header: "Target Delivery Date",
        cell: (info) => {
          const { target_delivery_date } = info.row.original;
          return <div className="flex items-center text-black">{target_delivery_date}</div>;
        },
      },
      {
        accessorKey: "payment_status",
        header: "Payment Status",
        cell: (info) => {
          const { payment_status } = info.row.original;
          return <div className="flex items-center text-black">{payment_status}</div>;
        },
      },
      {
        accessorKey: "description",
        header: "Description",
        cell: (info) => {
          const { description } = info.row.original;
          return <div className="flex items-center text-black">{description}</div>;
        },
      },

      // {
      //   accessorKey: "job_period_start",
      //   header: "Job Period Start",
      //   cell: (info) => {
      //     const { job_period_start } = info.row.original;
      //     return <div className="flex items-center text-black">{job_period_start}</div>;
      //   },
      // },
      // {
      //   accessorKey: "job_period_end",
      //   header: "Job Period End",
      //   cell: (info) => {
      //     const { job_period_end } = info.row.original;
      //     return <div className="flex items-center text-black">{job_period_end}</div>;
      //   },
      // },
      // {
      //   accessorKey: "invoice_number",
      //   header: "Invoice Number",
      //   cell: (info) => {
      //     const { invoice_number } = info.row.original;
      //     return <div className="flex items-center text-black">{invoice_number}</div>;
      //   },
      // },
      // {
      //   accessorKey: "time_tracked",
      //   header: "Time Tracked",
      //   cell: (info) => {
      //     const { time_tracked } = info.row.original;
      //     return <div className="flex items-center text-black">{time_tracked}</div>;
      //   },
      // },
      // {
      //   accessorKey: "project_cch_id",
      //   header: "CCH ID",
      //   cell: (info) => {
      //     const { project_cch_id } = info.row.original;
      //     return <div className="flex items-center text-black">{project_cch_id}</div>;
      //   },
      // },

      // {
      //   accessorKey: "description",
      //   header: "Description",

      //   cell: (info) => (
      //     <div className=" min-w-[200px] max-w-[15vw] overflow-hidden text-ellipsis whitespace-nowrap">
      //       <p>{info.getValue()}</p>
      //     </div>
      //   ),
      // },

      {
        accessorKey: "created_at",
        header: "Created At",
        cell: (info) => {
          const formatDate = (dateString) => {
            if (!dateString) {
              return ""; // Return a placeholder when dateString is null or undefined
            }
            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.toLocaleString("default", { month: "short" });
            const year = date.getFullYear(); // Get the year
            return `${day} ${month} ${year}`;
          };

          return <p>{formatDate(info.getValue())}</p>;
        },
      },
      {
        accessorKey: "created_by",
        header: "Created By",
        cell: (info) => <p>{info.getValue()}</p>,
      },
      {
        accessorKey: "updated_at",
        header: "Updated At",
        cell: (info) => {
          const formatDate = (dateString) => {
            if (!dateString) {
              return ""; // Return a placeholder when dateString is null or undefined
            }
            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.toLocaleString("default", { month: "short" });
            const year = date.getFullYear(); // Get the year
            return `${day} ${month} ${year}`;
          };

          return <p>{formatDate(info.getValue())}</p>;
        },
      },
      {
        accessorKey: "updated_by",
        header: "Updated By",
        cell: (info) => <p>{info.getValue()}</p>,
      },
      {
        accessorKey: "is_deletable",
        header: "",

        meta: { position: "left" },
        enableFiltering: false,
        enableColumnFilter: false,
        cell: (info) => {
          return (
            <div className="text-left w-[20px]">
              {info.row.original.is_deletable ? (
                <>
                  <button
                    className="text-F84545 text-15 text-left delete-button"
                    onClick={(e) => handleDeleteConfirmation(e, info.row.original)}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                      <path
                        d="M3.04017 5L3.9258 15.6912C3.98927 16.4622 4.646 17.0667 5.41993 17.0667H13.5801C14.354 17.0667 15.0108 16.4622 15.0742 15.6912L15.9598 5H3.04017ZM6.99953 15.0667C6.7378 15.0667 6.5176 14.8631 6.501 14.5979L6.001 6.53123C5.9839 6.25537 6.19337 6.01807 6.46877 6.00097C6.7544 5.98093 6.98147 6.19287 6.99903 6.46873L7.49903 14.5354C7.51673 14.8211 7.2907 15.0667 6.99953 15.0667ZM10 14.5667C10 14.843 9.77637 15.0667 9.5 15.0667C9.22363 15.0667 9 14.843 9 14.5667V6.5C9 6.22363 9.22363 6 9.5 6C9.77637 6 10 6.22363 10 6.5V14.5667ZM12.999 6.53127L12.499 14.5979C12.4826 14.8604 12.2638 15.0791 11.9687 15.0657C11.6933 15.0486 11.4839 14.8113 11.501 14.5354L12.001 6.46877C12.0181 6.1929 12.2598 5.9922 12.5312 6.001C12.8066 6.0181 13.0161 6.2554 12.999 6.53127Z"
                        fill="#F84545"
                      />
                      <path
                        d="M16 2H13V1.5C13 0.672867 12.3271 0 11.5 0H7.5C6.67287 0 6 0.672867 6 1.5V2H3C2.4477 2 2 2.4477 2 3C2 3.55223 2.4477 4 3 4C7.59887 4 11.4013 4 16 4C16.5523 4 17 3.55223 17 3C17 2.4477 16.5523 2 16 2ZM12 2H7V1.5C7 1.22413 7.22413 1 7.5 1H11.5C11.7759 1 12 1.22413 12 1.5V2Z"
                        fill="#F84545"
                      />
                    </svg>
                  </button>
                </>
              ) : null}
            </div>
          );
        },
      },
    ],
    [popupItemId, subtaskExpanded, leadType, completedTasks]
  );
  const [columnVisibility, setColumnVisibility] = useState({});

  const handleSort = (header, order) => {
    table.setSorting([
      {
        id: header.column.id, // Column ID to sort
        desc: order === "desc", // true for descending, false for ascending
      },
    ]);
  };
  const [deleteTask] = useDeleteTaskMutation();

  const [deleteProject] = useDeleteProjectMutation();

  const handleDeleteConfirmation = (e, data) => {
    e.stopPropagation();
    setDeleteData(data);
    setShowConfirmation(data?.category_id);
  };

  const handleDeleteTask = async (e, data) => {
    setShowConfirmation(false);
    e.stopPropagation();
    try {
      let response;
      if (data?.is_project) {
        response = await deleteProject({ token: token?.token, data }).unwrap();
      } else {
        response = await deleteTask({ token: token?.token, data }).unwrap();
      }

      if (response?.success) {
        dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
        refetchCustomerData();
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
      }
    } catch (error) {
      console.error("Failed to delete the task:", error);
    }
  };
  const {
    data: customerTableALL,
    isLoading,
    isFetching,
    refetch: refetchCustomerData,
  } = useFetchCustomerTaskPodTableDataQuery({
    customer_id: customerId,
    company_id: companyId,
    pagination: `${customerTablePagination}&per_page=1000`,
    paginate: true,
    quiFilter: quiFilter?.value,
    token: token,
    assign_id: userDataId?.id,
    // filter_tab: activeTab.slice(1),
    group_by_fields: newPayload,
    task_pod: taskpodPayload?.value,
    category_filter: leadType === "projects" ? "all_project" : leadType,
    visibility_status: activeTab.slice(1),
  });

  const repeatedData = useMemo(() => repeatData(customerTableALL?.data || [], 20), [customerTableALL?.data]);
  const getSubRows = (row) => row.sub_tasks || [];
  const memoizedData = useMemo(() => customerTableALL?.data || [], [customerTableALL]);
  console.log("memoizedData", customerTableALL);

  const table = useReactTable({
    data: memoizedData || [], // Use data from the hook or an empty array
    columns,
    // getSubRows: (row) => row?.sub_tasks || [],
    //getSubRows,
    filterFns: {
      fuzzy: fuzzyFilter, //define as a filter function that can be used in column definitions
    },
    initialState: {
      pagination: {
        pageSize: 25, // Set your desired default page size here
      },
    },
    state: {
      sorting,
      grouping,
      columnFilters,
      globalFilter,

      columnVisibility,
      // rowSelection,
      columnOrder,
    },
    // state: {
    //   grouping,
    // },
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: "fuzzy", //apply fuzzy filter to the global filter (most common use case for fuzzy filter)
    onColumnFiltersChange: setColumnFilters,
    onGroupingChange: setGrouping,
    getExpandedRowModel: getExpandedRowModel(),
    getGroupedRowModel: getGroupedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: setSorting,
    autoResetPageIndex: resetPageIndex,

    debugTable: true,
  });

  const resetFilters = () => {
    table.getAllColumns().forEach((column) => {
      if (column.getCanFilter()) {
        column.setFilterValue("");
      }
    });
  };

  useEffect(() => {
    // Calculate the total width of the table
    if (tableRef.current) {
      const tableWidth = tableRef.current.scrollWidth;
      const containerWidth = child1Ref.current.clientWidth;

      if (tableWidth > containerWidth + 20) {
        setScrollbarWidth(`${tableWidth}px`);
      } else {
        setScrollbarWidth("0px");
      }

      // setScrollbarWidth(`${tableWidth}px`);
    }
  }, [customerTableALL, isFilterActive, table.getState().pagination.pageSize, columnVisibility]);

  const [originalPageSize, setOriginalPageSize] = useState(null);

  const handleCellClick = (rowIndex, columnId) => {
    // console.log("clicked");

    const row = table.getRowModel().rows[rowIndex];
    // console.log("rowIndexabhi",rowIndex);
    //console.log("columnIdabhi",columnId);

    setSelectedCell({ rowIndex, columnId }); // Set selected cell
    setInputValue(row.getValue(columnId)); // Set input value to the current cell value
  };
  const renderDropdown = (columnId) => (
    <div className="absolute top-10 right-0 bg-white shadow-lg p-2 border border-gray-300 rounded z-[10]">
      <button onClick={() => handleGroupByClick(columnId)} className="block w-full text-left p-2 hover:bg-gray-200">
        Group By {columnId}
      </button>
    </div>
  );

  const handleGroupByClick = (columnId) => {
    setGrouping((prevGrouping) => {
      // Check if the column is already in the grouping list
      if (prevGrouping.includes(columnId)) {
        // If it is, remove it
        return prevGrouping.filter((id) => id !== columnId);
      } else {
        // Otherwise, add it
        return [...prevGrouping, columnId];
      }
    });
    setDropdownOpen(null); // Close dropdown after selection
  };

  useEffect(() => {
    refetchCustomerData();
    //setGroupedHeaders(newPayload)
  }, [newPayload, refetchCustomerData, leadType]); // Dependency on newPayload

  const formatEndDate = useFormatDate();

  const CircleSpan = styled("span")({
    display: "inline-block",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#ccc",
    textAlign: "center",
    lineHeight: "24px",
    fontSize: "12px",
    fontWeight: "bold",
    color: "#fff",
  });

  useEffect(() => {
    if (customerTableALL) {
      // setCustomer(customerTableALL?.data);

      if (!Array.isArray(customerTableALL?.data)) {
        setCustomer(Object.keys(customerTableALL?.data));
      } else {
        const { data, ...restData } = customerTableALL;

        setCustomer(data);
        setCustomerMainData(data);
        setInitialFilter(restData);
        setTotalData(customerTableALL?.total);

        setLoading(false);
      }
    }
  }, [customerTableALL, customerTablePagination, refetchCustomerData]);

  useEffect(() => {
    if (taskFormSubmit?.tasks?.data?.data) {
      refetchCustomerData();
    }
  }, [taskFormSubmit?.tasks?.data?.data, activeTab]);

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const fetchPersonData = (data) => fetchPersonInTable({ token: token?.token, data, companyId: companyId });

  const { data: quickpersonTableData } = useFetchPersonInTableQuery({
    token: token?.token,
    data: "",
  });

  const [updateCustomerTaskPodTableData, { CustomerDropLoad, CustomerDroperror }] =
    useUpdateCustomerTaskPodTableDataMutation();

  const [updateTaskCompletion, { isFetching: isTaskCompletionUpdating }] = useUpdateTaskCompletionMutation();

  const handleNavigate = (customer_id, data, projectsFlag) => {
    console.log("handle Navigate Hit");
    setIsEditPopupOpen(true);

    const isSubtask = data?.parent_task_id !== null;

    // Get the parent task data

    const parentTaskData = isSubtask
      ? customerMainData?.find((item) => item.id === data?.parent_task_id)
      : customerMainData?.find((item) => item.uuid === data?.uuid);

    if (parentTaskData) {
      const updatedFinalData = {
        ...parentTaskData,
        start: { value: parentTaskData?.start_date },
        end: { value: parentTaskData?.end_date },
      };
      setEditData(updatedFinalData);
    }
    if (projectsFlag) {
      setEditData(data);
      setOpenAddProject("edit");
    }
  };

  console.log(editData, "editData aakash handle Navigate Hit");
  useEffect(() => {
    dispatch(getUserTokeData());
  }, [location]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setResetPageIndex(true);
  };

  const openPopup = () => {
    if (leadType === "projects") {
      setOpenAddProject("add");
    } else {
      setIsPopupOpen(true);
    }

    dispatch(getUserTokeData());
  };

  useEffect(() => {
    if (!isPopupOpen) {
      setIsHovered(false);
    }
  }, [isPopupOpen]);

  const closePopup = () => {
    setIsCheckListOpen(false);
    setIsEditPopupOpen(false);
    setIsPopupOpen(false);
    setEditData();
  };

  const [CustomerTableDrop, { data: customerCommnData, refetch: refetchCustomerCommnData }] =
    useCustomerTableMutation();

  const fetchCustomerTable = (data) => {
    const completedata = {
      model_name: "task",
      field_name: data,
    };

    CustomerTableDrop({ token: token?.token, data: completedata });
  };

  const customerTableFieldUpdate = async (field_name, value) => {
    let datevalue;
    if (value?.field_name === "start_date" || value?.field_name === "end_date") {
      datevalue = stringData(field_name.value);
    } else {
      datevalue = value?.field_name === "owner" ? field_name.name : field_name.value;
    }

    const updateData = {
      field_name: value?.field_name,
      value: datevalue,
      id: value?.id,
    };

    try {
      const result = await updateCustomerTaskPodTableData({
        token: token?.token,
        data: updateData,
      }).unwrap();
      refetchCustomerData();
      setAlert({
        visible: true,
        message: result?.data?.original?.error || result?.message,
        type: result?.data?.original?.error ? "danger" : "success",
      });
    } catch (error) {
      setAlert({
        visible: true,
        message: "Error updating data!",
        type: "danger",
      });
    }
  };

  const [taskExpand, setTaskExpand] = useState(false);
  const TaskExpand = () => setTaskExpand(!taskExpand);
  const isOpen = () => {};
  const TaskNavbarQuickFilter = (option) => {
    setQuiFilter(option);
    setRefreshKey((prevKey) => prevKey + 1);
  };
  const FilterPodQuickFilter = (option) => {
    if (option?.value === "All") {
      setTaskpodPayload(null);
    } else {
      setTaskpodPayload(option);
      setRefreshKey((prevKey) => prevKey + 1);
    }
  };

  useEffect(() => {
    if (refreshKey) {
      refetchCustomerData();
    }
  }, [refreshKey]);

  const activityClosed = (val) => {
    refetchCustomerData();
  };

  let expandbtn = (
    <div className={`flex justify-end items-center mb-1`}>
      <div className="me-3">
        <NavBarTabs
          tabs={["Days", "Weeks", "Months"]}
          initialTab="Days"
          TabButtonClass="rounded px-3 py-1 cursor-pointer text-xs font-medium"
          activeStyle="bg-254155  text-white"
          inactiveStyle="bg-f1f6f9 text-434852"
          // onTabChange
        />
      </div>

      <button className="bg-white border border-E1E1E1 py-1 px-3" onClick={TaskExpand}>
        <i className="bi bi-arrows-fullscreen"></i>
      </button>
    </div>
  );

  // const changeToListView = () => {
  //   setListView(true);
  //   setCalView(false);
  // };

  // const changeToCaltView = () => {
  //   setListView(false);
  //   setCalView(true);
  // };

  //   const handleGridClick = () => {
  //     setIsGridActive(!isGridActive);
  //     changeToCaltView();
  //   };

  const handleEditFields = (selection) => {
    const Selectedaccordfield = { ...editData, selection };
    setEditData(Selectedaccordfield);
  };
  //   const handleToggle = (state) => {
  //     console.log("state", state);

  //     if (state) {
  //         changeToListView();
  //         return state
  //     } else {
  //         changeToCaltView();
  //         return state
  //     }

  // };

  const handleToggle = (state) => {
    setIsListView(state);
  };

  const ViewData = () => {
    return (
      <div className={`flex items-center justify-end ${calview ? "pb-1 pt-3" : ""}`}>
        <div
          className={`border-[1px] flex justify-center items-center rounded-l-[5px] rounded-r-[5px] border-[rgba(29, 68, 105, 0.20)] bg-white me-1`}
          role="group"
        >
          <ToggleSwitch
            leftEle={<ListIcon />}
            rightEle={<GridIcon />}
            onToggle={handleToggle}
            toggleState={isListView}
            className={"w-30 h-9"}
          />

          {!isListView && (
            <Fragment>
              <button
                onClick={() => setView("Day")}
                className={`h-[30px] text-12 text-848687 font-400 px-3 py-[5px] border-l border-[rgba(29, 68, 105, 0.20)] hover:bg-1D4469 hover:text-white ${view === "Day" ? "bg-1D4469 text-white" : ""}`}
              >
                Day
              </button>
              <button
                onClick={() => setView("Week")}
                className={`h-[30px] text-12 text-848687 font-400 px-3 py-[5px] border-l border-[rgba(29, 68, 105, 0.20)] hover:bg-1D4469 hover:text-white ${view === "Week" ? "bg-1D4469 text-white" : ""}`}
              >
                Week
              </button>
              <button
                onClick={() => setView("Month")}
                className={`h-[30px] text-12 text-848687 font-400 px-3 py-[5px] border-l border-[rgba(29, 68, 105, 0.20)] hover:bg-1D4469 hover:text-white ${view === "Month" ? "bg-1D4469 text-white rounded-r-[5px]" : ""}`}
              >
                Month
              </button>
            </Fragment>
          )}
        </div>
        {!isListView && (
          <button
            type="button"
            className="bg-1D4469 text-12 text-white rounded-5px h-[30px] w-[84px] border-[rgb(29 68 105 100%))] hover:bg-123251"
            onClick={() => {
              setStartDate(DayPilot.Date.today());
            }}
          >
            Today
          </button>
        )}
      </div>
    );
  };

  const handleToggleSubTasks = (taskid, data, header) => {
    setSubTaskOpen((prevState) => {
      if (prevState.includes(taskid)) {
        return prevState.filter((item) => item != taskid);
      } else {
        return [...prevState, taskid];
      }
    });
  };

  const handleRecurrence = (taskid, data, header) => {
    setIsEditPopupOpen(true);
    const finalData = customerMainData?.find((item) => item.task_status_id === data?.id?.value);

    if (finalData) {
      const updatedFinalData = {
        ...finalData,
        start: { value: finalData?.start_date },
        end: { value: finalData?.end_date },
      };

      setEditData(updatedFinalData);
    }
    // setEditData(finalData);
  };
  const kanbanChange = (e) => {
    const { value } = e.target;

    setKanBan(value);
  };
  console.log(kanban, "vinbaykanban");
  const UserIdBasedData = (data) => {
    setUserDataId(data);
  };

  const [isScrolling, setIsScrolling] = useState(false); // State to control scrolling

  useEffect(() => {
    let animationFrameId;

    // Function to handle auto-scrolling
    const autoScroll = () => {
      if (scrollDiv.current && isScrolling) {
        scrollDiv.current.scrollBy(0, 1); // Scroll down 1px
        animationFrameId = requestAnimationFrame(autoScroll); // Keep scrolling
      }
    };

    // Start scrolling when isScrolling is true
    if (isScrolling) {
      autoScroll();
    }

    // Cleanup on component unmount or when scrolling stops
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [isScrolling]);
  const toggleDropdown = (headerId) => {
    setOpenDropdownId((prevId) => (prevId === headerId ? null : headerId));
  };

  const handleChangeMainLead = (eachItem) => {
    setLeadType(eachItem?.value);
    if (customerTask) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("RightTab", eachItem?.rightTab);
      setSearchParams(newParams);
    } else {
      navigate(`/alltasks/${eachItem?.value}`);
    }
  };

  const requiredLeadtypeList =
    ["project", "projects"].includes(leadTypePath) || ["8", "13"].includes(rightTab) ? leadTypeList2 : leadTypeList1;
  return (
    <div className={` h-full`}>
      {(isFetching || isLoading) && <Loader isOpen={isFetching || isLoading} />}

      <div className="h-full shadow-[0_4px_6px_-4px_rgba(0,0,0,0.15)]">
        {/* <div className={`flex flex-wrap`}> */}
        {/* <div className={` ${taskExpand ? "hidden" : "w-[70%]"}  mt-3`}> */}
        <div className={`  h-full`}>
          <nav className=" h-full">
            <div className="container ">
              <div className="flex justify-between ">
                <div className="tablemaindiv customerTaskTable">
                  {isPopupOpen && (
                    // <div className="absolute  top-0 left-0 w-full flex justify-center items-center">
                    <AddTaskPodModal
                      isOpen={isOpen}
                      closePopup={closePopup}
                      taskid={editData}
                      taskPod={taskPod}
                      completeData={customerMainData}
                      key={refreshKey}
                      refetch={refetchCustomerData}
                      leadTypeValue={leadType}
                      customerTask={customerTask}
                      customerData={customerData}
                    />
                  )}

                  {editData?.is_recurrence === 0 && (
                    <div className="absolute  top-0 left-0 w-full flex justify-center items-center">
                      <AddTaskPodModal
                        isOpen={isOpen}
                        closePopup={closePopup}
                        taskid={editData}
                        completeData={customerMainData}
                        refetch={refetchCustomerData}
                        leadTypeValue={leadType}
                        checkListOpen={isCheckListOpen}
                        setCheckListOpen={setIsCheckListOpen}
                        customerTask={customerTask}
                        customerData={customerData}
                      />
                    </div>
                  )}
                  {showConfirmation && (
                    <ConfirmationDialog
                      open={showConfirmation}
                      onConfirm={(e) => handleDeleteTask(e, deleteData)}
                      onClose={() => setShowConfirmation(false)}
                      title={`Delete this ${showConfirmation} ?`}
                      // message={
                      //   <>
                      //     Are you sure you want to delete task -{" "}
                      //     <span className="font-medium">{showConfirmation}</span> ?
                      //   </>
                      // }
                      message={
                        <>
                          This task will be removed permanently and cannot be recovered.
                          <br />
                          <span className="font-medium"> Do you still want to delete it ?</span>
                        </>
                      }
                      confirmVariant="delete"
                      iconVariant="delete"
                      confirmText="Delete"
                      cancelText="Cancel"
                    />
                  )}

                  {editData?.is_recurrence === 1 && (
                    <EditOptionsTaskPodModal
                      onClose={closePopup}
                      onOpen={editData}
                      onSave={handleEditFields}
                      refetch={refetchCustomerData}
                      checkListOpen={isCheckListOpen}
                      setCheckListOpen={setIsCheckListOpen}
                    />
                  )}
                </div>
              </div>

              <div className="md:hidden">
                <button className="text-white focus:outline-none">
                  <ExpandCollapsIMG />
                </button>
              </div>
            </div>

            <div className={`h-full flex flex-col ${customerTask ? "" : "px-4 py-2"}`}>
              {isListView && (
                <>
                  <div className={`flex  mx-0  my-2 justify-between droppingarea gap-2 h-[28px]`}>
                    <div className="flex items-center rounded-md gap-2 bg-white  grow min-w-0 h-full">
                      {requiredLeadtypeList?.map((eachItem, i) => (
                        <button className="flex" onClick={() => handleChangeMainLead(eachItem)}>
                          <div
                            className={`${eachItem?.value === leadType ? "text-[white] bg-[#1D4469]" : "text-[#848687] "} ms-2 rounded-lg min-w-fit py-1 px-2 capitalize`}
                          >
                            {eachItem?.label}
                          </div>
                        </button>
                      ))}
                    </div>
                    <ToDoActiveButton
                      tabData={customerTableALL?.task_count}
                      tabColor={customerTableALL?.task_status_color}
                      activeTab={activeTab}
                      handleTabClick={handleTabClick}
                    />
                    {/* <ScrollableTabs
                      tabData={customerTableALL?.task_count}
                      tabColor={customerTableALL?.task_status_color}
                      activeTab={activeTab}
                      handleTabClick={handleTabClick}
                    /> */}
                    <div className="flex justify-between items-center gap-2 me-1">
                      {checkAccessPermission("Download") && (
                        <div className="w-[110px] bg-white h-8 items-center justify-center flex border border-[#D2DAE1] rounded-md shadow-[0px_1px_3px_0px_rgba(0,0,0,0.15)]">
                          <button
                            className="btn btn-success flex items-center gap-2"
                            onClick={() => exportExcel(table.getFilteredRowModel().rows)}
                          >
                            <RiFileExcel2Line style={{ color: "green", fontSize: "1.5rem" }} />
                            <span className="text-[#848687] text-sm font-normal">Download</span>
                          </button>
                        </div>
                      )}

                      <Fragment>
                        <div className="flex">
                          <select
                            onChange={kanbanChange}
                            className=" border-2 border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-DFE2E5  text-gray-500 text-sm block w-full h-8 py-0  pr-10"
                          >
                            <option value="List">List View</option>
                            <option value="Detail">Detail View</option>
                            <option value="Board">Board View</option>
                            <option value="Compact">Compact View</option>
                          </select>
                        </div>
                      </Fragment>

                      <div className="flex items-center   ">
                        {/* {tableDetail?.addbuttonToday} */}
                        {leadType === "task" && (
                          <>
                            {ViewData()}

                            <div>
                              <Fragment>
                                <div className="flex">
                                  <QuickFilter
                                    options={[
                                      { id: 0, name: "All", value: "All" },
                                      { id: 1, name: "Strategy", value: "Strategy" },
                                      { id: 2, name: "Tax", value: "Tax" },
                                      { id: 3, name: "Bookkeeping services", value: "Bookkeeping services" },
                                      { id: 4, name: "Testing", value: "Testing" },
                                      { id: 5, name: "Testing 001", value: "Testing 001" },
                                      { id: 6, name: "Vikas Kumar Sharma", value: "Vikas Kumar Sharma" },
                                    ]}
                                    placeholder={<span className="text-848687">{"Filter Pod"}</span>}
                                    onSelect={FilterPodQuickFilter}
                                  />
                                  <span className="mx-1"></span>
                                </div>
                              </Fragment>
                            </div>
                            <div>
                              <Fragment>
                                <div className="flex">
                                  <QuickFilter
                                    options={[
                                      { id: 1, name: "All", value: "" },
                                      { id: 2, name: "Due Today", value: "due_today" },
                                      { id: 3, name: "Due This Week", value: "due_this_week" },
                                      { id: 4, name: "Due Next Week", value: "due_next_week" },
                                      { id: 5, name: "Created by me", value: "created_by_user" },
                                      { id: 6, name: "Assigned To me", value: "assigned_to_me" },
                                    ]}
                                    placeholder={<span className="text-848687">{"Quick Filter"}</span>}
                                    onSelect={TaskNavbarQuickFilter}
                                  />
                                  <span className="mx-1"></span>
                                </div>
                              </Fragment>
                            </div>
                          </>
                        )}

                        <div>
                          <button onClick={openPopup} type="button" className="text-2541558A hover:text-254155">
                            <PlusIcon isActive={isPopupOpen} isHovered={isHovered} />
                          </button>
                        </div>
                        <div>
                          <SettingHeader
                            thead={storedThead}
                            setStoredThead={setStoredThead}
                            fromPage={"All Tasks"}
                            columnVisibility={columnVisibility}
                            setColumnVisibility={setColumnVisibility}
                            tableDetail={{ headeraddfield: false }}
                            handleMenuToggle={handleMenuToggle}
                            setMenuVisible={setMenuVisible}
                            menuVisible={menuVisible}
                            extraField={extraField}
                            setExtraField={setExtraField}
                          />
                        </div>

                        <div>
                          <button onClick={toggleFilterActive}>
                            <FilterIcon isHovered={isFilterHovered} isActive={isFilterActive} />
                          </button>
                        </div>

                        <div className="flex gap-1 ">
                          {isSearchActive && (
                            <DebouncedInput
                              value={globalFilter ?? ""}
                              onChange={(value) => setGlobalFilter(String(value))}
                              className="px-2 h-8 font-lg shadow border border-block "
                              placeholder="Search"
                            />
                          )}
                          <div>
                            <button onClick={toggleSearchIcon}>
                              <SearchIcon isHovered={isHovered} isActive={isSearchActive} />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {/* vinay add kanbanBoard */}
              {kanban === "Board" ? (
                <KanBanBoard />
              ) : (
                <>
                  {customerTableALL?.data.length > 0 && table.getRowModel().rows.length > 0 ? (
                    <div className="overflow-x-auto grow min-h-0 w-full flex flex-col">
                      <div
                        ref={child1Ref}
                        className="bg-white hide-scrollbar-x customscrollbar overflow-y-auto flex-grow"

                        //  style={{ height: "100%" }}
                      >
                        <table
                          ref={tableRef}
                          className="fullscreen-table min-w-full border-collapse  border border-gray-300 text-[13px] text-center font-poppins table-fixed text-2C495D overflow-auto"
                        >
                          <thead className="text-primary capitalize sticky bg-white border">
                            {table.getHeaderGroups().map((headerGroup) => (
                              <tr key={headerGroup.id}>
                                {headerGroup.headers.map((header) => {
                                  return (
                                    <th
                                      key={header.id}
                                      colSpan={header.colSpan}
                                      //className="border border-gray-300 p-2 text-left cursor-pointer relative whitespace-nowrap font-medium"
                                      className="relative pr-2 text-left  border whitespace-nowrap  text-ellipsis border-x-0 min-w-fit max-w-[20vw]"
                                      //style={{ width: "auto", minWidth: "2vw" }}
                                    >
                                      {header.isPlaceholder ? null : (
                                        <>
                                          <div
                                            className="flex justify-between gap-3 ms-4 min-h-6"
                                            //className={
                                            // header.column.getCanSort() ? "cursor-pointer select-none" : ""
                                            //}
                                            //onClick={header.column.getCanSort() ? header.column.getToggleSortingHandler() : undefined}
                                            // title={
                                            //   header.column.getCanSort()
                                            //     ? header.column.getNextSortingOrder() === "asc"
                                            //       ? "Sort ascending"
                                            //       : header.column.getNextSortingOrder() === "desc"
                                            //       ? "Sort descending"
                                            //       : "Clear sort"
                                            //     : undefined
                                            // }
                                          >
                                            {/* Grouping Button */}
                                            {/* {header.column.getCanGroup() ? (
                                    <button
                                      {...{
                                        onClick: header.column.getToggleGroupingHandler(),
                                        style: {
                                          cursor: "pointer",
                                        },
                                      }}
                                    >
                                      {header.column.getIsGrouped()
                                        ? `🛑(${header.column.getGroupedIndex()}) `
                                        : `👊 `}
                                    </button>
                                  ) : null} */}

                                            {/* Column Header */}
                                            <div className="text-primary ">
                                              {flexRender(header.column.columnDef.header, header.getContext())}
                                            </div>
                                            <div className="relative ">
                                              {!["completionAction", "is_deletable"].includes(header.id) && (
                                                <button
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleDropdown(header.id);
                                                  }}
                                                >
                                                  <ThreeDotsVertical className="fill-current" />
                                                </button>
                                              )}
                                            </div>
                                            {openDropdownId === header.id && (
                                              <div
                                                ref={dropdownRef}
                                                className="absolute right-[-55px] top-6 mt-2 w-40 bg-white border border-gray-300 shadow-lg rounded"
                                              >
                                                <ul>
                                                  <li
                                                    className="p-2 hover:bg-gray-100 cursor-pointer"
                                                    onClick={() => {
                                                      handleSort(header, "asc");
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    Sort by Increasing
                                                  </li>
                                                  <li
                                                    className="p-2 hover:bg-gray-100 cursor-pointer"
                                                    onClick={() => {
                                                      handleSort(header, "desc");
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    Sort by Decreasing
                                                  </li>
                                                  <li
                                                    className="p-2 hover:bg-gray-100 cursor-pointer"
                                                    onClick={() => {
                                                      header.column.getToggleGroupingHandler()();
                                                      setOpenDropdownId(null);
                                                    }}
                                                  >
                                                    <span className="block">
                                                      {" "}
                                                      {/* Ensure Group By/Stop Grouping By is on its own line */}
                                                      {header.column.getIsGrouped() ? "Stop Grouping By" : "Group By"}
                                                    </span>
                                                    <span className="block">
                                                      {" "}
                                                      {/* Ensure column name is on the next line */}
                                                      {flexRender(header.column.columnDef.header, header.getContext())}
                                                    </span>
                                                  </li>
                                                </ul>
                                              </div>
                                            )}

                                            {/* Sorting Indicators */}
                                            {/* {{
                                    asc: " 🔼",
                                    desc: " 🔽",
                                  }[header.column.getIsSorted() || ""] || null} */}
                                          </div>
                                          {/*Filter Input Box */}
                                          {header.column.getCanFilter() && isFilterActive ? (
                                            <div>
                                              <Filter column={header.column} />
                                            </div>
                                          ) : null}
                                        </>
                                      )}
                                    </th>
                                  );
                                })}
                              </tr>
                            ))}
                          </thead>
                          <tbody className="border">
                            {table.getRowModel().rows.map((row) => {
                              return (
                                <>
                                  <tr key={row.id} className="border  tablerow border-E1E6EC cursor-pointer">
                                    {row.getVisibleCells().map((cell) => {
                                      return (
                                        <td
                                          key={cell.id}
                                          className={`whitespace-nowrap border-b   border-neutral-200 text-2C495D font-normal text-left text-[12px] py-0.5`}
                                          style={{
                                            background: cell.getIsGrouped()
                                              ? ""
                                              : cell.getIsAggregated()
                                                ? ""
                                                : cell.getIsPlaceholder()
                                                  ? ""
                                                  : "white",
                                            marginLeft: cell.getIsGrouped()
                                              ? ""
                                              : cell.getIsAggregated()
                                                ? ""
                                                : cell.getIsPlaceholder()
                                                  ? "-30px"
                                                  : "white",
                                          }}
                                          onClick={
                                            !cell.getIsGrouped() &&
                                            !["activity", "customer_name"].includes(cell.column.id)
                                              ? (e) => {
                                                  e.stopPropagation();
                                                  handleNavigate(null, row.original, leadType === "projects");
                                                }
                                              : undefined
                                          }
                                        >
                                          {cell.getIsGrouped() ? (
                                            // If it's a grouped cell, add an expander and row count
                                            <>
                                              <button
                                                {...{
                                                  onClick: row.getToggleExpandedHandler(),
                                                  style: {
                                                    cursor: row.getCanExpand() ? "pointer" : "normal",
                                                  },
                                                }}
                                              >
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                  <span>{row.getIsExpanded() ? "▼" : "▶"}</span>
                                                  <span>
                                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                  </span>
                                                  <span>({row.subRows.length})</span>
                                                </div>
                                              </button>
                                            </>
                                          ) : cell.getIsAggregated() ? (
                                            // If the cell is aggregated, use the Aggregated
                                            // renderer for cell
                                            flexRender(
                                              cell.column.columnDef.aggregatedCell ?? cell.column.columnDef.cell,
                                              cell.getContext()
                                            )
                                          ) : cell.getIsPlaceholder() ? null : ( // For cells with repeated values, render null
                                            // Otherwise, just render the regular cell
                                            <div className="ms-5 text-black">
                                              {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </div>
                                          )}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                  {expanded[row.id] && // Check if the row has sub-rows and is expanded
                                    row.subRows.map((subRow) => (
                                      <tr key={subRow?.id} className="border-t border-gray-300 bg-gray-100">
                                        {subRow.getVisibleCells().map((subCell) => (
                                          <td
                                            key={subCell.id}
                                            className="border border-gray-300 p-2 whitespace-nowrap pl-8"
                                          >
                                            {subCell.column.columnDef.cell({
                                              getValue: subCell.getValue,
                                              row: subCell.row,
                                            })}
                                          </td>
                                        ))}
                                      </tr>
                                    ))}
                                  {subtaskExpanded[row.id] &&
                                    row.original.sub_tasks.map((subtask, subtaskIndex) => {
                                      return (
                                        <tr
                                          key={`subtask-${row.id}-${subtaskIndex}`}
                                          className="bg-gray-100 cursor-pointer"
                                        >
                                          {row.getVisibleCells().map((cell) => {
                                            // Create a context for the subtask using the existing cell context
                                            const subtaskContext = {
                                              ...cell.getContext(),
                                              row: {
                                                ...cell.getContext().row,
                                                original: subtask, // Replace original data with subtask data
                                              },
                                            };
                                            const isSubjectColumn = cell.column.id === "subject";
                                            const marginClass = isSubjectColumn ? "ms-12" : "ms-5";

                                            return (
                                              <td key={cell.id} onClick={(e) => handleNavigate(null, row.original)}>
                                                <div
                                                  className={`${marginClass} text-black text-[12px] text-left flex items-center`}
                                                >
                                                  {isSubjectColumn && (
                                                    <div className="flex items-center justify-center bg-white rounded-10px border w-[21px] h-[21px] mr-1">
                                                      <SubTaskIcon className="" />
                                                    </div>
                                                  )}
                                                  <div className="flex-1">
                                                    {flexRender(cell.column.columnDef.cell, subtaskContext)}
                                                  </div>
                                                </div>
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      );
                                    })}

                                  {/* {row.getIsExpanded() &&
                                  row.subRows.length > 0 &&
                                  row.subRows.map((subRow) => (
                                    <tr key={subRow.id} className="border tablerow border-E1E6EC ">
                                      {subRow.getVisibleCells().map((subCell) => (
                                        <td
                                          key={subCell.id}
                                          className={`whitespace-nowrap border-b    border-neutral-200 text-2C495D font-normal text-left text-[12px] py-0.5`}
                                        >
                                          <div className="ms-5 text-black text-[12px]">
                                            {flexRender(subCell.column.columnDef.cell, subCell.getContext())}
                                          </div>
                                        </td>
                                      ))}
                                    </tr>
                                  ))} */}

                                  {/* {row.getIsExpanded() && row.subRows.length > 0 && (
          row.subRows.map((subRow) => (
            <tr key={subRow.id} className="border tablerow border-E1E6EC">
              {subRow.getVisibleCells().map((subtaskCell) => (
                <td key={subtaskCell.id} className="border-b px-2 py-1 bg-gray-100">
                  {flexRender(subtaskCell.column.columnDef.cell, subtaskCell.getContext())}
                </td>
              ))}
            </tr>
          ))
        )} */}
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      <div className="flex items-center justify-between bg-white gap-2 px-4 py-1.5 border border-[#D2DAE1] rounded-b-lg ">
                        <div ref={paginationRef} className="flex min-w-fit auto flex-grow gap-3">
                          {/* Page Size Selector */}
                          {/* <select
                            value={table.getState().pagination.pageSize}
                            onChange={(e) => table.setPageSize(Number(e.target.value))}
                            className="text-sm text-[#535252]  items-center  text-center p-0 border-[#DDE1E3] font-medium flex gap-2 px-2  "
                          >
                            {[25, 50, 100].map((pageSize) => (
                              <option key={pageSize} value={pageSize} >
                                {pageSize}
                              </option>
                            ))}
                           
                          </select> */}
                          <div className="relative w-fit" ref={dropdownRef}>
                            {/* <div
                            onClick={() => setOpen(!open)}
                            className="text-sm text-[#535252] cursor-pointer items-center text-center p-1 px-2 h-[32px] border border-[#DDE1E3] font-medium flex gap-2 rounded"
                          >
                            {table.getState().pagination.pageSize}
                            <AddSubTaskDownArrow />
                          </div>
 
                          {open && (
                            <div
                              className={`absolute z-10 bg-white border border-[#DDE1E3] -mb-0 rounded w-full  ${
                                dropUp ? "bottom-full mb-1" : "top-full mt-1"
                              }`}
                            >
                              {pageSizes.map((pageSize) => (
                                <div
                                  key={pageSize}
                                  onClick={() => {
                                    table.setPageSize(pageSize);
                                    setOpen(false);
                                  }}
                                  className="px-3 py-1 text-sm text-[#535252] hover:bg-gray-200 text-center cursor-pointer "
                                >
                                  {pageSize}
                                </div>
                              ))}
                            </div>
                          )} */}

                            <BasicSelect
                              options={pageSizes || []}
                              place
                              name="pageSize"
                              selectedOptions={pageSizes?.filter(
                                (option) => option?.value === table.getState().pagination.pageSize
                              )}
                              onChange={(e) => table.setPageSize(Number(e.target.value))}
                              onClick={() => {
                                table.setPageSize(pageSizes[0]?.value);
                              }}
                              type={"select"}
                              size={"medium"}
                            />
                          </div>

                          {/* Pagination Controls */}
                          <div className="bg-white min-w-fit ">
                            <ul className="globalpagination  border rounded border-[#DDE1E3] text-sm font-medium text-[#535252]  py-[0.16875rem]  items-center justify-center flex gap-1">
                              {/* First Page */}
                              <li>
                                <button
                                  className="hover:border-[#D4D5D6] px-1 py-0.5 rounded text-[#535252]"
                                  onClick={() => {
                                    table.setPageIndex(0);
                                  }}
                                  disabled={!table.getCanPreviousPage()}
                                >
                                  <i className="bi bi-chevron-double-left   text-sm font-medium text-[#535252]"></i>
                                </button>
                              </li>

                              {/* Previous Page */}
                              <li>
                                <button
                                  className="hover:border-[#D4D5D6] px-1 py-0.5 rounded "
                                  onClick={() => {
                                    table.previousPage();
                                    setResetPageIndex(false);
                                  }}
                                  disabled={!table.getCanPreviousPage()}
                                >
                                  <i className="bi bi-chevron-left font-medium"></i>
                                </button>
                              </li>

                              {/* Page Numbers */}
                              {pageNumbers().map((page, index) => (
                                <li
                                  key={index}
                                  className={`${
                                    table.getState().pagination.pageIndex === page - 1
                                      ? "  border-383838 border  hover:border-[#D4D5D6]  rounded items-center " // Apply red border for active page
                                      : "" // Default border color for inactive pages
                                  } rounded  flex items-center justify-center `} // Set padding for square shape
                                >
                                  {page === "..." ? (
                                    <span className=" rounded ">...</span>
                                  ) : (
                                    <button
                                      className={` text-sm font-medium  ${
                                        table.getState().pagination.pageIndex === page - 1
                                          ? "px-2 border-383838"
                                          : "hover:border-[#D4D5D6]  rounded items-center  py-0.5 px-2" // Ensure the button is square
                                      }`}
                                      style={{ color: "#535252" }}
                                      onClick={() => {
                                        table.setPageIndex(page - 1);
                                        setResetPageIndex(false);
                                      }}
                                    >
                                      {page}
                                    </button>
                                  )}
                                </li>
                              ))}

                              {/* Next Page */}
                              <li>
                                <button
                                  className="rounded hover:border-[#D4D5D6] px-1 py-0.5  "
                                  onClick={() => {
                                    table.nextPage();
                                    setResetPageIndex(false);
                                  }}
                                  disabled={!table.getCanNextPage()}
                                >
                                  <i className="bi bi-chevron-right font-medium"></i>
                                </button>
                              </li>

                              {/* Last Page */}
                              <li>
                                <button
                                  className="rounded hover:border-[#D4D5D6] px-1 py-0.5 "
                                  onClick={() => {
                                    table.setPageIndex(table.getPageCount() - 1);
                                    setResetPageIndex(false);
                                  }}
                                  disabled={!table.getCanNextPage()}
                                >
                                  <i className="bi bi-chevron-double-right font-medium"></i>
                                </button>
                              </li>
                            </ul>
                          </div>

                          {/* Total Records */}
                          <div className="flex items-center">
                            <p className=" bg-none  bg-white font-medium text-sm  text-535252 min-w-fit flex items-center gap-1">
                              <span> Count</span>
                              <span className="mt-[-1px]"> :: </span>
                              <span> {table.getFilteredRowModel().rows.length}</span>
                            </p>
                          </div>
                        </div>
                        <div className={` ${scrollbarWidth === "0px" ? "hidden" : ""}`}>
                          <ThreeDotsVertical />
                        </div>
                        <div className="flex justify-between items-center w-1/2 ml-1/4">
                          <button
                            className={`z-50 mr-[-20px] bg-[#5d5f60] bg-opacity-100 text-white px-2 h-[15px] text-sm rounded-l-full flex items-center justify-center ${
                              scrollbarWidth === "0px" ? "hidden" : ""
                            }`}
                            onClick={() => handleScroll("previous")}
                          >
                            <span className="" style={{ fontSize: "7.5px" }}>
                              &#9664;
                            </span>
                          </button>
                          <div
                            className={`flex-grow overflow-x-auto overflow-y-hidden scrollbar-thin customscrollbar1 h-[15px] w-[calc(100%-${scrollbarWidth})] `}
                            style={{}}
                            ref={scrollbarWrapperRef}
                          >
                            <div
                              style={{
                                width: `calc(${scrollbarWidth} - ${paginationRef?.current?.clientWidth}px)`,
                                height: "1px",
                              }}
                            ></div>
                          </div>
                          <button
                            className={`z-50 ml-[-20px]  bg-[#5d5f60] bg-opacity-100 text-white px-2 h-[15px] text-sm rounded-r-full flex items-center justify-center ${
                              scrollbarWidth === "0px" ? "hidden" : ""
                            }`}
                            onClick={() => handleScroll("next")}
                          >
                            <span className="" style={{ fontSize: "7.5px" }}>
                              &#9654;
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="text-center mt-2 h-full">
                        <div className="flex justify-center items-center flex-col space-y-4 h-full">
                          <NewNoTaskIcon className="w-[300px] h-[300px]" />
                          <span className="text-14 text-black text-sm font-400">No Data Available</span>
                          {/* <button className="border px-5 py-1  bg-white cursor-pointer items-center text-center text-base font-medium  hover:border-[#1D4469] hover:text-[#1D4469] text-[#383838] rounded-md shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]">
                            + Add Folder
                          </button> */}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

              {!isListView && (
                <Fragment>
                  {ViewData()}
                  <TaskPodRecurrenceCalendar
                    setView={setView}
                    view={view}
                    setStartDate={setStartDate}
                    startDate={startDate}
                  />
                </Fragment>
              )}
              {console.log(customerId, "customerId")}
              {openAddProject && (
                <AddViewProjectDrawer
                  open={openAddProject}
                  setOpen={setOpenAddProject}
                  onClose={() => setOpenAddProject(false)}
                  customerTaskPodAllCustomer={customerTaskPodAllCustomer}
                  setJobFormData={setProjectFormData}
                  projectId={editData?.project_id}
                  getFieldValue={getFieldValue}
                  projectFieldList={projectFieldList}
                  fetchPersonInTable={fetchPersonData}
                  personTableData={personTableData}
                  selectedCustomer={{ id: customerId || projectFormData?.customer_id }}
                  refetch={refetchCustomerData}
                />
              )}
            </div>
          </nav>
        </div>
        {/* <div className={` ${taskExpand ? "w-[3%]" : "hidden"}`}>
          {taskExpand && expandbtn}
          <div className="no-scrollbar h-[500px] overflow-y-auto">
          </div>
        </div>
        <div className={` ${taskExpand ? "w-[97%]" : "hidden"} ps-4`}>
          <div className="flex justify-between"></div>
          <div className="no-scrollbar h-[500px] overflow-y-auto">
            <div className="px-4 py-5 flex-auto bg-white">
              <p>Gantt Chart</p>
            </div>
          </div>
        </div>

        <div className={`${taskExpand ? "hidden" : "w-[30%]"} mt-2 ps-4`}>
          {!taskExpand && expandbtn}

          <GentChart className="w-100" />
        </div> */}
      </div>
    </div>
  );
};
const repeatData = (data, repeatCount) => {
  if (!Array.isArray(data) || data.length === 0) return [];
  return Array.from({ length: repeatCount }, () => data).flat();
};
function Filter({ column }) {
  const columnFilterValue = column.getFilterValue();
  const { filterVariant } = column.columnDef.meta || {};

  return filterVariant === "range" ? (
    <div>
      <div className="flex space-x-2">
        {/* See faceted column filters example for min max values functionality */}
        <DebouncedInput
          type="number"
          value={(columnFilterValue && columnFilterValue[0]) || ""}
          onChange={(value) => column.setFilterValue((old) => [value, old ? old[1] : undefined])}
          placeholder={`Min`}
          className="w-24 border shadow rounded"
        />
        <DebouncedInput
          type="number"
          value={(columnFilterValue && columnFilterValue[1]) || ""}
          onChange={(value) => column.setFilterValue((old) => [old ? old[0] : undefined, value])}
          placeholder={`Max`}
          className="w-24 border shadow rounded"
        />
      </div>
      <div className="h-1" />
    </div>
  ) : filterVariant === "select" ? (
    <select
      onChange={(e) => column.setFilterValue(e.target.value)}
      value={columnFilterValue ? columnFilterValue.toString() : ""}
    >
      {/* See faceted column filters example for dynamic select options */}
      <option value="">All</option>
      <option value="complicated">complicated</option>
      <option value="relationship">relationship</option>
      <option value="single">single</option>
    </select>
  ) : (
    <input
      className="w-36 border shadow rounded placeholder:pl-1"
      onChange={(e) => {
        column.setFilterValue(e.target.value);
      }}
      placeholder={`Search...`}
      type="text"
      value={columnFilterValue || ""}
    />

    // <DebouncedInput
    //   className="w-36 border shadow rounded"
    //   onChange={value => column.setFilterValue(value)}
    //   placeholder={`Search...`}
    //   type="text"
    //   value={columnFilterValue || ''}
    // />
    // See faceted column filters example for datalist search suggestions
  );
}
function DebouncedInput({ value: initialValue, onChange, debounce = 200, ...props }) {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue); // Sync the input value with the parent prop
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value); // Call the parent onChange handler after debounce
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, debounce, onChange]); // Debounce the value change

  return (
    <input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)} // Update internal value on change
      className="text-black text-xs border-none outline-none bg-white p-3"
    />
  );
}

const TaskTable = (props) => {
  const { customerTask } = props;
  const { leadTypePath } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const rightTab = searchParams.get("RightTab"); // returns "8"
  console.log(rightTab, "rightTab aakash");

  const WrappedComponent = useMemo(() => LayoutHOC(AllTasks), [leadTypePath]); // Memoize the wrapped component

  const RefreshedAllTask = useMemo(() => AllTasks, [rightTab]);

  return customerTask ? <RefreshedAllTask key={rightTab} {...props} /> : <WrappedComponent {...props} />;
};

export default TaskTable;
